var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReviewStars(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 88,
    height: 16,
    viewBox: "0 0 88 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0H0V16H16V0Z",
    fill: "#00B67A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00039 10.7833L10.4337 10.1666L11.4504 13.3L8.00039 10.7833ZM13.6004 6.73328H9.31706L8.00039 2.69995L6.68372 6.73328H2.40039L5.86706 9.23329L4.55039 13.2666L8.01706 10.7666L10.1504 9.23329L13.6004 6.73328Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34 0H18V16H34V0Z",
    fill: "#00B67A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9984 10.7833L28.4318 10.1666L29.4484 13.3L25.9984 10.7833ZM31.5984 6.73328H27.3151L25.9984 2.69995L24.6818 6.73328H20.3984L23.8651 9.23329L22.5484 13.2666L26.0151 10.7666L28.1484 9.23329L31.5984 6.73328Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M52 0H36V16H52V0Z",
    fill: "#00B67A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9984 10.7833L46.4318 10.1666L47.4484 13.3L43.9984 10.7833ZM49.5984 6.73328H45.3151L43.9984 2.69995L42.6818 6.73328H38.3984L41.8651 9.23329L40.5484 13.2666L44.0151 10.7666L46.1484 9.23329L49.5984 6.73328Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M70 0H54V16H70V0Z",
    fill: "#00B67A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M61.9984 10.7833L64.4318 10.1666L65.4484 13.3L61.9984 10.7833ZM67.5984 6.73328H63.3151L61.9984 2.69995L60.6818 6.73328H56.3984L59.8651 9.23329L58.5484 13.2666L62.0151 10.7666L64.1484 9.23329L67.5984 6.73328Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M88 0H72V16H88V0Z",
    fill: "#DCDCE5"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M79.9984 10.7833L82.4318 10.1666L83.4484 13.3L79.9984 10.7833ZM85.5984 6.73328H81.3151L79.9984 2.69995L78.6818 6.73328H74.3984L77.8651 9.23329L76.5484 13.2666L80.0151 10.7666L82.1484 9.23329L85.5984 6.73328Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviewStars);
export default __webpack_public_path__ + "static/media/review_stars.a1b1be23673d7c4984e7bec818a45f25.svg";
export { ForwardRef as ReactComponent };